export default __webpack_public_path__ + "media/siteware/favicon-228-409c016da8c32deb1cbbc08ca407a380.png";